import { css, Interpolation, Theme } from '@emotion/react'

export const container: Interpolation<Theme> = css`
  position: relative;
  width: 100%;
  height: 100%;
`

export const tableWrapper: Interpolation<Theme> = (theme) => css`
  .table-row .actions {
    box-sizing: border-box;
    height: 24px;
    display: flex;
    gap: 12px;
    align-items: end;
    transition: all ${theme.transitions.duration.standard}ms ${theme.transitions.easing.easeInOut};
    overflow: hidden;
  }

  .table-row:not(:hover) .actions {
    height: 0;
  }
`

export const titleWrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
`

export const headerWrapper = (theme: Theme) => css`
  ${theme.breakpoints.down(580)} {
    width: 100%;
    flex-direction: column;
    align-items: end;
  }
`

export const search = (theme: Theme) => css`
  ${theme.breakpoints.down(580)} {
    width: 100%;
  }
`

export const paginationTake: Interpolation<Theme> = (theme) => css`
  margin-bottom: ${theme.spacing(2)};
`

export const action: Interpolation<Theme> = css`
  height: 18px;
  padding: 0;
  min-width: 0;

  &.MuiButtonBase-root:hover {
    background: none;
  }
`
